import { makeStyles } from '@material-ui/core/styles'
import { COLORS, FONTS } from '../../../constants'

export const styles = makeStyles(theme => ({
  grid: {
    marginBottom: 32,
  },
  card: {
    height: '100%',
    padding: theme.spacing(2.5, 2.5, 2),
    borderRadius: 14,
    border: `1px solid ${COLORS.ashGrey}`,
    backgroundColor: COLORS.whiteStain,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    flexDirection: 'column',
    transition: theme.transitions.create(
      ['box-shadow', 'transform', 'border-color'],
      { duration: theme.transitions.duration.short }
    ),
    '&:hover': {
      boxShadow: '0 12px 28px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-3px)',
    },
  },
  highlightCard: {
    borderColor: COLORS.infoBlue,
    backgroundColor: '#EEF4FA',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  iconBadge: {
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    color: COLORS.darkGrey,
  },
  highlightIconBadge: {
    backgroundColor: 'rgba(13, 60, 97, 0.12)',
    color: COLORS.infoBlue,
  },
  cardLabel: {
    fontFamily: FONTS.Graphik.GraphikRegular,
    textTransform: 'lowercase',
    color: COLORS.darkGrey,
    fontSize: '0.8125rem',
    letterSpacing: '0.02em',
    margin: 0,
  },
  cardValue: {
    fontFamily: FONTS.Schnyder.SchnyderLLight,
    fontSize: '2.25rem',
    lineHeight: 1.15,
    letterSpacing: '-0.01em',
    fontVariantNumeric: 'tabular-nums',
    margin: 0,
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
      fontSize: '1.875rem',
    },
  },
  cardCaption: {
    fontFamily: FONTS.Graphik.GraphikLight,
    fontSize: '0.75rem',
    lineHeight: 1.5,
    color: COLORS.darkGrey,
    textTransform: 'lowercase',
    marginTop: 8,
  },
}))
